/**
 * @author PoornaChandu
 */
import React, { useState,useEffect } from 'react';
import { Checkbox, Tree, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { TreeNode } = Tree;
const HierarchyModal = (props) => {
  const [treeData, setTreeData] = useState(props.treeData || []);
  const [checkedArray, setCheckedArray] = useState(props.replicateDevicesList || []);
  
  useEffect(() => {
    setCheckedArray(props.replicateDevicesList);
  }, [props.replicateDevicesList]);
  useEffect(() => {
    if ( props.replicateDevicesList !== checkedArray) {
      setTreeData(props.treeData);
      setCheckedArray(checkedArray);
    }
    if (props.treeData !== treeData){
      setTreeData(props.treeData);

    }
  }, [props.treeData, props.replicateDevicesList]);
  // const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
  //   if (obj && obj.children) {
  //     let children = obj.children.map((objChildren) => {
  //       return renameProperty(objChildren, oldName1, newName1, oldName2, newName2);
  //     });
  //     obj['children'] = children;
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   } else {
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   }
  // };
  // const getMenuHierarchyStructure = () => {
  //   JSON.parse(localStorage.get('modules'));
  //   if (treeData) {
  //     return treeData.map((userHierarchy) => {
  //       return renameProperty(userHierarchy, 'label', 'title', 'value', 'key');
  //     });
  //   }
  // };
  const getData = (item) => {
    const { Key } = props;
    if (Key === 'Asset') {
      if (item && item.Type === 'Site') {
        message.error('Cant select site');
      } else if (item.Type !== 'Device') {
        props.handleDropdownChange(item);
      } else {
        message.error('Please select valid input');
      }
    } else if (Key === 'Rule' || Key === 'Replicate') {
      if (item && item.Type === 'Site') {
        message.error('Cant select site');
      } else if (item.Type !== 'Device') {
        message.error('Please select Device');
      } else if (item.Type === 'Device') {
        props.handleDropdownChange(item);
        getParent(item.Name, item.ParentId, treeData);
      }
    }
  };
  const getParent = (Name, ParentId, treeData) => {
    let firstLevelParent = {};
    let children = [];
    let secondLevelParent = [];
    for (let i = 0; i < treeData.length; i++) {
      const node = treeData[i];
      if (node.children) {
        if (node.children.some((item) => item.Id === ParentId)) {
          firstLevelParent = node;
          children = node.children;
          if (children) {
            for (let i = 0; i < children.length; i++) {
              const childNode = children[i];
              if (childNode.children && childNode.children.length > 0) {
                if (childNode.Id === ParentId) {
                  secondLevelParent = childNode;
                }
              }
            }
          }
          if (props.handleParentNode) {
            props.handleParentNode(firstLevelParent, secondLevelParent);
          }
        } else if (getParent(Name, ParentId, node.children)) {
          getParent(Name, ParentId, node.children);
        }
      }
    }
    return firstLevelParent;
  };

  // checkboxOnChange = (e) => {
  //   const { checkedArray } = this.state;
  //   const value = e.target.value;
  //   let updatedCheckedArray;
  //   if (e.target.checked) {
  //     updatedCheckedArray = [...new Set([...checkedArray, value])];
  //   } else {
  //     updatedCheckedArray = checkedArray.filter((val) => val !== value);
  //   }
  //   this.setState({
  //     checkedArray: updatedCheckedArray
  //   }, () => {
  //     this.props.handleDropdownChange(updatedCheckedArray);
  //   });
  // };
    const checkboxOnChange = (e) => {
    const value = e.target.value;
    setCheckedArray(value);
    let updatedCheckedArray;
    if (e.target.checked) {
      updatedCheckedArray = checkedArray.concat(value);
    } else {
      updatedCheckedArray = checkedArray.filter((val) => val !== value);
    }
    setCheckedArray(updatedCheckedArray);
    props.handleDropdownChange(updatedCheckedArray);
  };
  const setTranslation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const renderTreeNodes = (data) => {
    let { Key } = props;
    return (
      data &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={
                <div onClick={() => getData(item)}>
                  {` ${item.DisplayCode ? `${setTranslation(item.DisplayCode)} ` : ''} ${
                    item.Name ? `(${setTranslation(item.Name)})` : ''
                  }`}
                </div>
              }
              key={item.Id}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        
        if (Key === 'Replicate') {
          return (
            <TreeNode
              key={item.Id}
              title={
                <div>
                  {item.Type === 'Device' ? (
                    <>
                      <Checkbox
                        key={item.Id}
                        onClick={(e) => checkboxOnChange(e)}
                        checked={checkedArray &&
                          Array.isArray(checkedArray) &&
                          checkedArray.some((checkedItem) => checkedItem === item.Name)
                        }
                        value={item.Name}
                      />
                      {` ${item.DisplayCode ? `${setTranslation(item.DisplayCode)} ` : ''} ${
                        item.Name ? `(${setTranslation(item.Name)})` : ''
                      }`}
                    </>
                  ) : (
                    <>
                    <div onClick={() => getData(item)}>
                      {` ${item.DisplayCode ? `${setTranslation(item.DisplayCode)} ` : ''} ${
                        item.Name ? `(${setTranslation(item.Name)})` : ''
                      }`}
                    </div>
                    </>
                  )}
                </div>
              }
              dataRef={item}
            />
          );
        } else {
          return (
            <TreeNode
              key={item.Id}
              title={
                <div onClick={() => getData(item)}>
                  {` ${item.DisplayCode ? `${setTranslation(item.DisplayCode)} ` : ''} ${
                    item.Name ? `(${setTranslation(item.Name)})` : ''
                  }`}
                </div>
              }
              dataRef={item}
            />
          );
        }
      })
    );
  };
  // const onExpand = (expandedKeys) => {
  //   setExpandedKeys(expandedKeys);
  //   setAutoExpandParent(false);
  // };
    return (
      <div
        style={{
          width: '100%',
          flex: '35%',
          overflowY: 'auto',
          height: window.innerHeight - 250
        }}
      >
        {props.Key === 'Replicate' ? (
          <Tree
            showLine
            checkedKeys={checkedArray}
            defaultExpandAll={true}
            switcherIcon={<DownOutlined />}
   >
            {renderTreeNodes(treeData)}
          </Tree>
        ) : (
          <Tree
            showLine
            defaultExpandAll={true}
            switcherIcon={<DownOutlined />}
          >
            {renderTreeNodes(treeData)}
          </Tree>
        )}
      </div>
    );
};
export default HierarchyModal;
